import { render, staticRenderFns } from "./CommonTaks.vue?vue&type=template&id=8e5dc252&"
import script from "./CommonTaks.vue?vue&type=script&lang=js&"
export * from "./CommonTaks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports